// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();

  if (!user) {
    // If the user is not logged in, redirect them to the /login page.
    return <Navigate to="/login" />;
  }

  // If the user is logged in, render the page they were trying to access.
  return children;
};

export default ProtectedRoute;